import { render, staticRenderFns } from "./forgotPasswordSupport.vue?vue&type=template&id=845e9964"
import script from "./forgotPasswordSupport.vue?vue&type=script&lang=js"
export * from "./forgotPasswordSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports